import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { FloorScreedRemote } from '../../common/widgets';
import { initWidgetDataWithShops } from '../init-widget-data-with-shops';

registerWidget<State, Record<string, string>>(`${__NAME__}/floor-screed`, state => {
  const router = getGlobalRouter();
  const store = initWidgetDataWithShops(state);

  return remoteProps => <FloorScreedRemote router={router} store={store} {...remoteProps} />;
});
